export interface IUserSearchResult {
        username: string;
        emailAddress: string;
        agentCode: string;
        displayName: string;
        windowsUserName: string;
        isApproved: boolean;
      }

export class UserSearchResult implements IUserSearchResult {
        public username: string;
        public emailAddress: string;
        public agentCode: string;
        public displayName: string;
        public windowsUserName: string;
        public isApproved: boolean;
      }
